/**
 * Created by lu on 2018/5/24.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: nb.Model,
    method: {
        init: function () {

        }}
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/notice/MsgItem.js
// module id = 29
// module chunks = 0 1 2 3 4 7 8 9 10 12 13 14 15 16 18 19 20 21 22 23 25 26 27 28 29 30 34